import React from 'react';

const WebsiteLoading = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center z-50">
      <div className="text-center">
        {/* Pulsing Circles Loader */}
        <div className="mb-8 relative flex items-center justify-center">
          <div className="absolute w-24 h-24 border-4 border-[#00336a] rounded-full opacity-20 animate-ping"></div>
          <div className="absolute w-20 h-20 border-4 border-[#00336a] rounded-full opacity-40 animate-ping" style={{ animationDelay: '0.2s' }}></div>
          <div className="relative w-16 h-16 bg-[#00336a] rounded-full flex items-center justify-center shadow-lg">
            <div className="w-8 h-8 bg-white rounded-full"></div>
          </div>
        </div>
        
        {/* Loading text with wave animation */}
        <div className="space-y-3">
          <div className="flex justify-center items-center space-x-1">
            <span className="text-[#00336a] text-2xl font-bold" style={{ animation: 'wave 1.5s ease-in-out infinite', animationDelay: '0s' }}>L</span>
            <span className="text-[#00336a] text-2xl font-bold" style={{ animation: 'wave 1.5s ease-in-out infinite', animationDelay: '0.1s' }}>o</span>
            <span className="text-[#00336a] text-2xl font-bold" style={{ animation: 'wave 1.5s ease-in-out infinite', animationDelay: '0.2s' }}>a</span>
            <span className="text-[#00336a] text-2xl font-bold" style={{ animation: 'wave 1.5s ease-in-out infinite', animationDelay: '0.3s' }}>d</span>
            <span className="text-[#00336a] text-2xl font-bold" style={{ animation: 'wave 1.5s ease-in-out infinite', animationDelay: '0.4s' }}>i</span>
            <span className="text-[#00336a] text-2xl font-bold" style={{ animation: 'wave 1.5s ease-in-out infinite', animationDelay: '0.5s' }}>n</span>
            <span className="text-[#00336a] text-2xl font-bold" style={{ animation: 'wave 1.5s ease-in-out infinite', animationDelay: '0.6s' }}>g</span>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes wave {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default WebsiteLoading;
